import { Dropdown } from "antd";
import { useState, useCallback } from "react";
import classNames from "classnames";
import styled from "styled-components";
import { faTimes } from "@fortawesome/pro-light-svg-icons";
import { faPlus, faMinus } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { useDocumentClickOutsideTarget } from "common/hooks/index";

import { FilterTokenMenu } from "./FilterTokenMenu";

export function FilterToken(props) {
    const [menuOpen, setMenuOpen] = useState(false);
    
    const handleClickOutsideDropDown = useCallback(() => setMenuOpen(false), []);
    useDocumentClickOutsideTarget(handleClickOutsideDropDown, ".token");
    const { token } = props;
    
    const deleteToken = (e) => {
        e.preventDefault();
        props.onDelete(token, props.temp);
    };
    
    const onApply = (updatedTokenData) => {
        props.onUpdate({ ...updatedTokenData, category: token.category });
    };
    
    const onCancel = () => {
        setMenuOpen(false);
    };
    
    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };
    
    const tip = !(token.pivot_alias && token.alias) ? token.label : `${token.pivot_alias}: ${token.alias}`;
    const tokenBodyIcon = token.operator === "=" ? faPlus : faMinus;
    
    const tokenBody = (nomenu = false) => (
        <div className={classNames("token-inner-wrapper", { "no-menu": nomenu })} data-toggle="tooltip" title={tip}>
            <span className="operator">
                <FontAwesomeIcon aria-hidden icon={tokenBodyIcon} />
            </span>
            <span className="token-label">{token.token_alias || token.ref}</span>
        </div>
    );
    
    const tokenMenu = () => {
        const menu = () => (
            <FilterTokenMenu onApply={onApply} onCancel={onCancel} data={props.data} token={token} selectedItems={props.selectedItems}/>
        );
        if (props.temp === false && !props.hideMenu) {
            return (
                // TODO: deprecate overlay, refactor menu
                <Dropdown overlay={menu} placement="bottomLeft" open={menuOpen} onClick={toggleMenu} getPopupContainer={(trigger) => trigger}>
                    <TokenMenu>{tokenBody()}</TokenMenu>
                </Dropdown>
            );
        }
        return tokenBody(true);
    };
    
    return (
        <div className={classNames("token", { "not-applied": props.temp }, { include: token.operator === "=" }, { "read-only": props.isReadOnly }, { exclude: token.operator === "!=" })}>
            {tokenMenu()}
            {!props.isReadOnly
                && (
                <a href="#" className="close" tabIndex="-1" onClick={deleteToken} >
                    <FontAwesomeIcon className="token-close-icon" aria-hidden icon={faTimes} />
                </a>
                )}
        </div>
    );
}

const TokenMenu = styled.div`
    height: 100%;
    .token-menu {
        padding: 5px 3px;
        opacity: 1.0;
        min-height: 350px;
        width: 258px;
        min-width: 202px;
        background: ${(props) => props.theme.colors["canvas-white"]};
        z-index: 999;
        border: 1px solid ${(props) => props.theme.colors["gray-soft"]};
        .operator-toggle {
            padding-bottom: 10px;
            text-transform: uppercase;

            header {
                padding-bottom: 5px;
            }

            .btns {
                .btn {
                    width: 125px;
                    text-align: center;
                    border-radius: 4px;
                    background: ${(props) => props.theme.colors["canvas-mid"]};
                    border: 1px solid ${(props) => props.theme.colors["canvas-mid"]};
                    color: ${(props) => props.theme.colors["gray-mid"]};

                    &.left {
                        border-top-right-radius: 0;
                        border-bottom-right-radius: 0;
                    }

                    &.right {
                        border-top-left-radius: 0;
                        border-bottom-left-radius: 0;
                    }
                }

                &.included {
                    .left {
                        cursor: default;
                        background: ${(props) => props.theme.colors["green-leaf"]};
                        border: 1px solid ${(props) => props.theme.colors["green-leaf"]};
                        color: ${(props) => props.theme.colors["canvas-white"]};
                    }

                    .right:hover {
                        background: ${(props) => props.theme.colors["canvas-white"]};
                        border: 1px solid ${(props) => props.theme.colors["gray-soft"]};
                    }

                    li.selected {
                        color: ${(props) => props.theme.colors["green-leaf"]};
                    }
                }

                &.excluded {
                    .right {
                        cursor: default;
                        background: ${(props) => props.theme.colors.jason};
                        border: ${(props) => props.theme.colors.jason};
                        color: ${(props) => props.theme.colors["canvas-white"]};
                    }

                    .left:hover {
                        background: ${(props) => props.theme.colors["canvas-white"]};
                        border: 1px solid ${(props) => props.theme.colors["gray-soft"]};
                    }

                    li.selected {
                        color: ${(props) => props.theme.colors.jason};
                    }
                }
            }

        }

        .menu-filter {
            border: 1px solid ${(props) => props.theme.colors["gray-soft"]};
            margin-bottom: 5px;
            height: 30px;
            width: 250px;

            .icon {
                display: none;
            }

            .typeahead-wrapper {
                position: relative;
                display: inline-block;
                height: 30px;
                max-height: 30px;

                .suggestion {
                    position: absolute;
                    z-index: 2;
                    top: 0;
                    left: 0;
                    height: 20px;
                    width: 225px;
                    pointer-events: none;
                    padding-left: 0;
                    margin-top: 5px;
                    box-shadow: none;
                    white-space: nowrap;
                    overflow: hidden;
                    color: ${(props) => props.theme.colors["gray-light"]};
                }

                .tt-input {
                    position: absolute;
                    top: 0;
                    left: 0;
                    z-index: 3;
                    display: inline-block;
                    border: 0;
                    background: none;
                    min-width: 60px;
                    max-width: 200px;
                    height: 20px;
                    width: 225px;
                    padding-left: 0;
                    margin-top: 5px;
                    box-shadow: none;
                }

                &.type-ahead-icon {
                    .icon {
                        position: absolute;
                        z-index: 1;
                        top: 8px;
                        left: 5px;
                    }

                    .suggestion, .tt-input {
                        position: absolute;
                        padding-left: 25px;
                    }
                }
            }
        }


        .list {
            .operator-icon {
                min-height: 28px;
                height: 28px;
                min-width: 24px;
                width: 24px;

                .included, .excluded {
                    display: none;
                    margin-top: 2px;
                    height: 16px;
                    width: 16px;
                }

                &.selected.included {
                    .included {
                        display: inline-block;
                    }
                }

                &.selected.excluded {
                    .excluded {
                        display: inline-block;
                    }
                }
            }
        }

        .btn-row {
            margin: auto;
            padding-top: 10px;

            .btn {
                margin-left: 10px;
                width: 226px;
            }
        }

        .cancel-row {
            border: 1px solid ${(props) => props.theme.colors.brick};
            height: 28px;
            margin: auto;
            text-align: center;

            .cancel {
                color: ${(props) => props.theme.colors["gray-new"]};
                width: 150px;
                text-align: center;
            }
        }

        .text {
            .form-control {
                min-height: 44px;
                padding-top: 11px;

                .markup {
                    position: relative;
                    width: 100%;
                    padding-right: 20px;
                    display: flex;
                    top: -2px;

                    &.controls-visible {
                        padding-right: 110px;
                    }

                    .query-builder-text-input {
                        flex-grow: 1;
                        border: none;

                        &:focus {
                            outline: none;
                        }
                    }

                    .text-apply {
                        flex-grow: 0;
                        width: auto;
                        padding: 0 10px;
                        margin-right: 5px;
                        line-height: 24px;
                        font-size: ${(props) => props.theme.fontSizeLarge};
                        border-radius: 2px;

                        &:hover {
                            text-decoration: none;
                        }
                    }
                }
            }
        }
    }
`;
